import { Radio } from "@blueprintjs/core";
import { useWhatChanged } from "@simbathesailor/use-what-changed";
import { FGDateMaskInput, FGTextInput, FieldGroup, useFGContext } from "nsitools-react";
import * as React from "react";

import { EDogSex } from "../../../api";
import { FGDogSearchInput, FGSRSHDateMaskInput } from "../../../components";
import { useTl } from "../../../hooks";
import { ETLCodes } from "../../../locales";

export interface IFusionRadioProps {
  elementName: string;
  elementNameBis: string;
  fusedElementName: string;
  label: ETLCodes;
  elementValue: any;
  elementValueBis: any;
  isDate?: boolean;
  sex?: EDogSex;
  selectLeft?: boolean;
}

export const FusionRadio: React.FunctionComponent<IFusionRadioProps> = ({
  elementName,
  elementNameBis,
  fusedElementName,
  label,
  elementValue,
  elementValueBis,
  isDate = false,
  sex,
  selectLeft = null,
}) => {
  const [fusionRadioValue, setFusionRadioValue] = React.useState(selectLeft !== null ? (selectLeft ? "1" : "2") : "1");
  const [oldFusionValue, setOldFusionValue] = React.useState(fusionRadioValue);
  const { formik } = useFGContext();
  const { t } = useTl();

  React.useEffect(() => {
    setFusionRadioValue(selectLeft !== null ? (selectLeft ? "1" : "2") : "1");
  }, [selectLeft]);

  React.useEffect(() => {
    console.log(`For element [${fusedElementName}] => OLD [${oldFusionValue}] === NEW [${fusionRadioValue}]`);
    if (
      oldFusionValue !== fusionRadioValue &&
      ((fusionRadioValue == "1" && formik.values.fusedElementName !== elementValue) ||
        (fusionRadioValue == "0" && formik.values.fusedElementName !== elementValueBis))
    ) {
      if (fusionRadioValue === "1") {
        console.log(`Set ${fusedElementName} to ${elementValue}`);
        formik.setFieldValue(fusedElementName, elementValue);
      } else {
        console.log(`Set ${fusedElementName} to ${elementValueBis}`);
        formik.setFieldValue(fusedElementName, elementValueBis);
      }
      setOldFusionValue(fusionRadioValue);
    }
  }, [elementValue, elementValueBis, formik, fusedElementName, fusionRadioValue, oldFusionValue]);

  useWhatChanged([sex, elementName], "sex, elementName");

  return (
    <>
      <div style={{ display: "flex" }}>
        <FieldGroup>
          <FieldGroup columns={[11, 1]}>
            {isDate ? (
              <FGSRSHDateMaskInput name={elementName} label={t(label)} readonly />
            ) : sex ? (
              <FGDogSearchInput defaultSearch={{ sex }} label={t(label)} name={elementName} readonly />
            ) : (
              <FGTextInput name={elementName} label={t(label)} readonly />
            )}

            <Radio
              style={{ margin: "0.4rem 0rem" }}
              value="1"
              checked={fusionRadioValue === "1"}
              onChange={(c) => {
                setFusionRadioValue(c.currentTarget.value);
                console.log(`Set ${fusedElementName} to ${elementValue}`);
                formik.setFieldValue(fusedElementName, elementValue);
              }}
            />
          </FieldGroup>
        </FieldGroup>
        {/*==================================================================================================*/}
        <FieldGroup>
          <div style={{ marginLeft: "14rem" }}>
            <FieldGroup columns={[11, 1]}>
              {isDate ? (
                <FGSRSHDateMaskInput name={elementNameBis} label={t(label)} readonly />
              ) : sex ? (
                <FGDogSearchInput defaultSearch={{ sex }} label={t(label)} name={elementNameBis} readonly />
              ) : (
                <FGTextInput name={elementNameBis} label={t(label)} readonly />
              )}
              <Radio
                style={{ margin: "0.4rem 0rem" }}
                value="2"
                checked={fusionRadioValue === "2"}
                onChange={(c) => {
                  setFusionRadioValue(c.currentTarget.value);
                  console.log(`Set ${fusedElementName} to ${elementValueBis}`);
                  formik.setFieldValue(fusedElementName, elementValueBis);
                }}
              />
            </FieldGroup>
          </div>
        </FieldGroup>
      </div>
    </>
  );
};
